// Legacy flat keys still referenced by old i18n.t() calls. Machine-drafted — review before launch.
const legacyEs: Record<string, string> = {
	addteamMemberbtn: 'Añadir miembro del equipo',
	appsumo_code: 'Código AppSumo',
	card_delivered: 'Esta tarjeta ya ha sido entregada.',
	cards: 'Tarjetas',
	change_pass: 'Cambiar contraseña',
	confirm_pass: 'Confirmar nueva contraseña',
	create_new_card: 'Crear tarjeta',
	draft: 'Borrador',
	email: 'Correo electrónico',
	enter_appsumo_code: 'Introduce el código AppSumo',
	enter_email_address: 'Introduce tu correo electrónico',
	firstName: 'Nombre',
	generate_card_preview: 'Espera mientras generamos la vista previa de la tarjeta',
	lastName: 'Apellido',
	login: 'Inicia sesión en tu cuenta',
	logout: 'Cerrar sesión',
	my: 'Mis',
	new_pass: 'Nueva contraseña',
	not_a_valid_file: 'Archivo no válido.',
	page_not_found_header: 'La página que buscas no está aquí',
	page_not_found_para: 'Intentaste una ruta incorrecta o llegaste aquí por error. Sea como sea, usa la navegación.',
	pricing: 'Precios',
	register: 'Registrarse',
	savebtn: 'Guardar',
	scheduled: 'Programado',
	select_from_collection: 'Seleccionar de la colección',
	updatebtn: 'Actualizar perfil',
	updateteamMemberbtn: 'Actualizar',
	upload_image: 'Subir imagen',
	your_email_address: 'Correo electrónico',
	checkout_desc_1: 'Selecciona uno de los diseños ilustrados de nuestros artistas como portada, o crea el tuyo',
	checkout_desc_2: 'Diseña tu tarjeta con una colección de fuentes, colores y estilos de texto, y sube tus propias imágenes.',
	checkout_desc_3: 'Nuestra función de compartir te permite invitar a todos los que quieran unirse a escribir un saludo',
	checkout_desc_4: 'Elige la fecha de esta entrega especial para el envío automático.',
	checkout_heading_1: 'Elige diseños ilustrados',
	checkout_heading_2: 'Diseña y firma',
	checkout_heading_3: 'Colabora y comparte',
	checkout_heading_4: 'Entrega automática programada',
};
export default legacyEs;
